import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/ouvidoria/form_status'
import Head from '../../../../components/head'


function EditarOuvidScreen () {
    return (
        <Fragment>
            <Head titulo="Atualizando Situação" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarOuvidScreen;